import { Button } from "../components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const ROWS_PER_PAGE = 50;

export function paginate(items, currentPage) {
  const totalPages = Math.max(1, Math.ceil(items.length / ROWS_PER_PAGE));
  const paginated = items.slice((currentPage - 1) * ROWS_PER_PAGE, currentPage * ROWS_PER_PAGE);
  return { paginated, totalPages, totalItems: items.length };
}

export function PaginationControls({ currentPage, totalPages, totalItems, setCurrentPage, testIdPrefix = "pagination" }) {
  if (totalItems <= ROWS_PER_PAGE) return null;

  const startItem = (currentPage - 1) * ROWS_PER_PAGE + 1;
  const endItem = Math.min(currentPage * ROWS_PER_PAGE, totalItems);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 bg-[#11141D] border border-white/5 rounded-xl px-4 py-3" data-testid={`${testIdPrefix}-controls`}>
      <p className="text-xs text-slate-500">
        Showing {startItem}–{endItem} of {totalItems}
      </p>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={() => setCurrentPage(1)} disabled={currentPage === 1} className="h-8 px-2 bg-[#0B0D12] border-white/10 text-slate-300 disabled:opacity-30" data-testid={`${testIdPrefix}-first`}>
          First
        </Button>
        <Button variant="outline" size="sm" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} className="h-8 w-8 p-0 bg-[#0B0D12] border-white/10 text-slate-300 disabled:opacity-30" data-testid={`${testIdPrefix}-prev`}>
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="text-sm text-slate-300 px-2 tabular-nums">
          Page {currentPage} of {totalPages}
        </span>
        <Button variant="outline" size="sm" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="h-8 w-8 p-0 bg-[#0B0D12] border-white/10 text-slate-300 disabled:opacity-30" data-testid={`${testIdPrefix}-next`}>
          <ChevronRight className="h-4 w-4" />
        </Button>
        <Button variant="outline" size="sm" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} className="h-8 px-2 bg-[#0B0D12] border-white/10 text-slate-300 disabled:opacity-30" data-testid={`${testIdPrefix}-last`}>
          Last
        </Button>
      </div>
    </div>
  );
}
